import React, { useState } from "react";
import axios from "axios";
// import { toast } from "react-toastify";
import { FaUpload } from "react-icons/fa";
import Cookies from "js-cookie";
import { Notification } from "../../../../Notification";
const UploadDiscrepancyPopup = ({ onClose, setRefresh }) => {
  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false); // Track upload state
  const [isDownloading, setIsDownloading] = useState(false); // Track download state

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      console.log("Selected file:", file.name);
    }
  };

  const handleSubmit = async () => {
    if (isUploading) return; // Prevent multiple uploads from rapid clicking
    if (!selectedFile) {
      Notification("Please select a file first!", "info");
      return;
    }

    setIsUploading(true); // Freeze button
    try {
      const formData = new FormData();
      formData.append("file", selectedFile);
      const token = Cookies.get("session");

      const response = await axios.post(
        `${REACT_APP_BACKEND_URL}/dispreancy/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Upload response:", response);
      const isSuccess = (response.data.uploadedCount ?? 1) > 0;
      Notification(
        response.data.message || (isSuccess ? "Discrepancies uploaded successfully" : "No discrepancies uploaded"),
        isSuccess ? "success" : "warning"
      );

      setRefresh((prev) => !prev); // Toggle state for parent refresh ✅
      onClose(); // Close the modal AFTER state change ✅
    } catch (err) {
      Notification(err.response?.data?.error || "Upload failed", "error");
    } finally {
      setIsUploading(false); // Unfreeze button after completion
    }
  };

  const handleDownload = async () => {
    setIsDownloading(true); // Start loading
    try {
      const token = Cookies.get("session");

      const response = await axios.get(
        `${REACT_APP_BACKEND_URL}/dispreancy/download-excel`,
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
          responseType: "arraybuffer", // ✅ Fixes file corruption
        }
      );

      // Create a Blob from the response data
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Create a temporary download link
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "Weight_Discrepancy_Sample_Format.xlsx"; // ✅ Corrected filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Cleanup

      Notification("File downloaded successfully!", "success");
    } catch (error) {
      console.error("Download error:", error);
      Notification("Failed to download file!", "error");
    } finally {
      setIsDownloading(false); // Stop loading
    }
  };

  return (
    <div className="fixed inset-0 flex animate-popup-in items-center justify-center bg-black bg-opacity-50 z-[1000]">
      <div className="bg-white p-4 rounded-lg shadow-lg w-[400px] relative">
        <h2 className="text-[12px] sm:text-[14px] font-bold mb-2">Upload Weight Discrepancy</h2>

        <p className="text-[10px] sm:text-[12px] text-gray-600">
          Download Sample File{" "}
          <span
            className={`text-brand-primary hover:underline cursor-pointer ${isDownloading ? "opacity-50 cursor-not-allowed" : ""}`}
            onClick={!isDownloading ? handleDownload : null}
          >
            {isDownloading ? "Downloading..." : "click here"}
          </span>
        </p>

        <label className="cursor-pointer flex text-[12px] sm:text-[14px] items-center gap-2 text-brand-primary bg-white px-4 py-2 mt-4 rounded-lg border border-brand-primary transition">
          <div className="flex justify-between items-center w-full">
            <span>Upload File</span>
            <FaUpload className="text-brand-primary" />
          </div>
          <input type="file" className="hidden" onChange={handleFileChange} />
        </label>

        {selectedFile && (
          <p className="text-[10px] sm:text-[12px] text-gray-500">Selected: {selectedFile.name}</p>
        )}

        {/* Submit Button - Disabled when uploading */}
        <button
          onClick={handleSubmit}
          disabled={isUploading}
          className={`px-4 py-2 mt-2 rounded-lg text-[10px] sm:text-[12px] font-[600] transition-all ${isUploading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-brand-primary text-white hover:bg-green-500"
            }`}
        >
          {isUploading ? "Uploading..." : "Submit"}
        </button>

        {/* Close Button */}
        <button
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
          onClick={onClose}
          disabled={isUploading} // Disable closing while uploading
        >
          ✖
        </button>
      </div>
    </div>
  );
};

export default UploadDiscrepancyPopup;
